var alignmentStyle = {"alignLeft":"yB5gh","textWrapNowrap":"t4nXU","alignRight":"jsqGu","alignCenter":"ipI3p","sizeFullWidth":"wWkBK","renderedInTable":"eGcT-","sizeOriginal":"rnGre","sizeContent":"uL1nM","sizeSmall":"HhCne","sizeSmallCenter":"TouI-","flex":"_5AMnu","LEFT":"_0AUC8","CENTER":"e5qA2","RIGHT":"jPsqh","AUTO":"_50p6F","JUSTIFY":"JX2vh"};

export { alignmentStyle as a };
//# sourceMappingURL=alignment.rtlignore-a30bcaff.js.map
